import { useMemo } from "react";
import { useSuprimentos } from "@/hooks/useSuprimentos";
import { buildGameState } from "./gameUtils";
import { GameState } from "./gameTypes";

export function useGameState(startDate: string, endDate: string): GameState {
  const { data, loading, error } = useSuprimentos({
    startDate,
    endDate,
    costCenter: [],
    constructiveUnit: [],
    itemFilter: [],
    quotationFilter: "",
    purchaseRequestFilter: "",
    orderFilter: "",
    supplierFilter: [],
  });

  const derived = useMemo(() => {
    if (!data) return null;
    return buildGameState(data);
  }, [data]);

  if (loading || !derived) {
    return {
      zones: [],
      creatures: [],
      encounters: [],
      totalOrdersValue: 0,
      totalOrdersCount: 0,
      playerLevel: 1,
      playerXp: 0,
      loading,
      error: error ?? null,
    };
  }

  return { ...derived, loading: false, error: null };
}
